export enum RecurrenceType {
  Master = 0,
  GeneratedInstance = 1,
}
